import { render, staticRenderFns } from "./CartaoDeCondicoesDePagamento.vue?vue&type=template&id=bf39a30e&scoped=true"
import script from "./CartaoDeCondicoesDePagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeCondicoesDePagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeCondicoesDePagamento.vue?vue&type=style&index=0&id=bf39a30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf39a30e",
  null
  
)

export default component.exports